export const REVENUE_CREATE_REQUEST = 'REVENUE_CREATE_REQUEST';
export const REVENUE_CREATE_SUCCESS = 'REVENUE_CREATE_SUCCESS';
export const REVENUE_CREATE_FAIL = 'REVENUE_CREATE_FAIL';

export const REVENUE_LIST_REQUEST = 'REVENUE_LIST_REQUEST';
export const REVENUE_LIST_SUCCESS = 'REVENUE_LIST_SUCCESS';
export const REVENUE_LIST_FAIL = 'REVENUE_LIST_FAIL';
export const REVENUE_LIST_RESET = 'REVENUE_LIST_RESET';

export const REVENUE_DELETE_REQUEST = 'REVENUE_DELETE_REQUEST';
export const REVENUE_DELETE_SUCCESS = 'REVENUE_DELETE_SUCCESS';
export const REVENUE_DELETE_FAIL = 'REVENUE_DELETE_FAIL';

export const REVENUE_DETAILS_REQUEST = 'REVENUE_DETAILS_REQUEST';
export const REVENUE_DETAILS_SUCCESS = 'REVENUE_DETAILS_SUCCESS';
export const REVENUE_DETAILS_FAIL = 'REVENUE_DETAILS_FAIL';
export const REVENUE_DETAILS_RESET = 'REVENUE_DETAILS_RESET';

export const REVENUE_UPDATE_REQUEST = 'REVENUE_UPDATE_REQUEST';
export const REVENUE_UPDATE_SUCCESS = 'REVENUE_UPDATE_SUCCESS';
export const REVENUE_UPDATE_FAIL = 'REVENUE_UPDATE_FAIL';
export const REVENUE_UPDATE_RESET = 'REVENUE_UPDATE_RESET';
